import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/penaltyRecord/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/penaltyRecord'
  }
]
